import { isMultilingual } from '../../languages';
// the phone number can also be found in src/json/landingsLocalities
// if it has to be modified, don't forget to modify it in this file also
const phoneNumberInter = '+33184800539';
const phoneNumber = isMultilingual ? '+33184800539' : '01.84.80.05.39';

const mail = 'contact@tilli.fr';
const tillisteMail = 'savoirfaire@tilli.fr';

export default {
  phoneNumber, phoneNumberInter, mail, tillisteMail,
};
